export default __webpack_public_path__ + "static/media/xmark.4ff16bc6.svg";